import React, { useState, useEffect } from 'react';
import {
  IonInput,
  IonItem,
  IonLabel,
  IonButton,
  IonList,
  IonToast,
  IonListHeader,
  IonIcon
} from '@ionic/react';
import { useAuth0 } from '@auth0/auth0-react';
import { registerCamera, listCameras, deleteCamera } from '../services/api';
import LayoutWrapper from '../components/LayoutWrapper';
import { trash } from 'ionicons/icons';
import { IonSpinner } from '@ionic/react';

const RegisterCamera: React.FC = () => {
  const [name, setName] = useState('');
  const [rtsp, setRtsp] = useState('');
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);
  const [zone_x1, setZoneX1] = useState<number>(0);
  const [zone_x2, setZoneX2] = useState<number>(0);
  const [zone_y1, setZoneY1] = useState<number>(0);
  const [zone_y2, setZoneY2] = useState<number>(0);
  const [showToast, setShowToast] = useState(false);
  const [cameras, setCameras] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const { getAccessTokenSilently } = useAuth0();

  const fetchCameras = async (token: string) => {
    setLoading(true);
    try {
      const data = await listCameras(token);
      setCameras(data);
    } catch {
      setCameras([]);
    }
    setLoading(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = await getAccessTokenSilently();
      await registerCamera(name, rtsp, width, height, zone_x1, zone_x2, zone_y1, zone_y2, token);
      setShowToast(true);
      setName('');
      setRtsp('');
      setWidth(0);
      setHeight(0);
      setZoneX1(0);
      setZoneX2(0);
      setZoneY1(0);
      setZoneY2(0);
      await fetchCameras(token);
    } catch (err) {
      alert('Erro ao cadastrar câmera');
    }
  };

  useEffect(() => {
    (async () => {
      const token = await getAccessTokenSilently();
      await fetchCameras(token);
    })();
    // eslint-disable-next-line
  }, [getAccessTokenSilently]);

  return (
    <LayoutWrapper title="Cadastrar Câmera">
      <form onSubmit={handleSubmit}>
        <IonList>
          <IonItem>
            <IonLabel position="stacked">Nome da Câmera</IonLabel>
            <IonInput
              value={name}
              placeholder="Digite o nome"
              onIonChange={e => setName(e.detail.value!)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Endereço RTSP</IonLabel>
            <IonInput
              value={rtsp}
              placeholder="rtsp://..."
              onIonChange={e => setRtsp(e.detail.value!)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Largura (Width)</IonLabel>
            <IonInput
              value={width}
              type="number"
              placeholder="Resolução largura"
              onIonChange={e => setWidth(e.detail.value ? parseInt(e.detail.value, 10) : 0)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Altura (Height)</IonLabel>
            <IonInput
              value={height}
              type="number"
              placeholder="Resolução altura"
              onIonChange={e => setHeight(e.detail.value ? parseInt(e.detail.value, 10) : 0)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Zona X1</IonLabel>
            <IonInput
              value={zone_x1}
              type="number"
              placeholder="Coordenada Zona X1"
              onIonChange={e => setZoneX1(e.detail.value ? parseInt(e.detail.value, 10) : 0)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Zona X2</IonLabel>
            <IonInput
              value={zone_x2}
              type="number"
              placeholder="Coordenada Zona X2"
              onIonChange={e => setZoneX2(e.detail.value ? parseInt(e.detail.value, 10) : 0)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Zona Y1</IonLabel>
            <IonInput
              value={zone_y1}
              type="number"
              placeholder="Coordenada Zona Y1"
              onIonChange={e => setZoneY1(e.detail.value ? parseInt(e.detail.value, 10) : 0)}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Zona Y2</IonLabel>
            <IonInput
              value={zone_y2}
              type="number"
              placeholder="Coordenada Zona Y2"
              onIonChange={e => setZoneY2(e.detail.value ? parseInt(e.detail.value, 10) : 0)}
              required
            />
          </IonItem>
        </IonList>
        <IonButton expand="block" type="submit" className="ion-margin-top">
          Cadastrar
        </IonButton>
      </form>
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message="Câmera cadastrada com sucesso!"
        duration={2000}
        color="success"
      />
      <IonList>
        <IonListHeader>
          <IonLabel>Minhas Câmeras</IonLabel>
        </IonListHeader>
        {loading ? (
          <IonItem>
            <IonLabel>Carregando...</IonLabel>
          </IonItem>
        ) : cameras.length === 0 ? (
          <IonItem>
            <IonLabel>Nenhuma câmera cadastrada.</IonLabel>
          </IonItem>
        ) : (
          cameras.map((cam) => (
            <IonItem key={cam.id}>
              <IonLabel>
                <b>{cam.name}</b>
                <div style={{ fontSize: '0.9em', color: '#888' }}>{cam.rtsp}</div>
                <div style={{ fontSize: '0.9em', color: '#888' }}>
                  Width: {cam.width} | Height: {cam.height} | Zona X1: {cam.zone_x1} | Zona X2: {cam.zone_x2} | Zona Y1: {cam.zone_y1} | Zona Y2: {cam.zone_y2}
                </div>
              </IonLabel>
              <IonButton
                slot="end"
                color="danger"
                fill="clear"
                disabled={deletingId === cam.id}
                onClick={async () => {
                  const token = await getAccessTokenSilently();
                  setDeletingId(cam.id);
                  try {
                    await deleteCamera(cam.id, token);
                    setCameras(cameras.filter(c => c.id !== cam.id));
                  } catch {
                    alert('Erro ao deletar câmera');
                  }
                  setDeletingId(null);
                }}
              >
                {deletingId === cam.id ? (
                  <IonSpinner name="dots" />
                ) : (
                  <IonIcon icon={trash} />
                )}
              </IonButton>
            </IonItem>
          ))
        )}
      </IonList>
    </LayoutWrapper>
  );
};

export default RegisterCamera;